module.exports = __webpack_public_path__ + "static/img/12.d881b1b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/zh/12.png
// module id = 7ZeD
// module chunks = 0